// extracted by mini-css-extract-plugin
export default {"countBubble":"ListBubble_countBubble__Tf5ox"};